

export type ObjectFit = "contain" | "cover" | "fill" | "scale-down" | "none"

export const ObjectFitOptions = [{
    id: "contain",
    name: "Contain",
},
{
    id: "cover",
    name: "Cover",
},
{
    id: "fill",
    name: "Fill",
}
]


export function resolveObjectFit(objectFit: string | null | undefined): ObjectFit {
    if (!objectFit) {
        return "cover"
    }

    const option = ObjectFitOptions.find(option => option.id === objectFit);

    return (option ? option.id : "cover") as ObjectFit
}